import { Component, OnInit,Inject } from '@angular/core';
import { MatDialog,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExcelViewerService } from 'src/app/repository/service/excel-viewer.service';
@Component({
  selector: 'app-kpi-grid-row-name-edit',
  templateUrl: './kpi-grid-row-name-edit.component.html',
  styleUrls: ['./kpi-grid-row-name-edit.component.scss']
})
export class KpiGridRowNameEditComponent implements OnInit {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data:{newName:string,realName:string},
    public matDialog:MatDialog,
    public evService:ExcelViewerService,
    ) { }

  ngOnInit(): void {
    // console.log(this.data.newName);
  }

  closeDialog(){
    this.matDialog.closeAll();
  }

  changeApply(data:string){
    this.evService.applyChangeForEditRowName = data;
  }

}
